import { Navigate } from "react-router-dom";
// Preserve old bookmarks and notification links. Friend requests live in Notification Center.
export default function Activity() {
  return <Navigate to="/notifications" replace />;
}
